import * as types from "./clientActionTypes";

const initialState = {
  data: null,
};

export default function clientReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case types.SET_LAST_GENERATED_MEMBER:
      return {
        ...state,
        data: payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/clientReducer.js